import {useTranslations} from 'next-intl';

export default function ShopDataShowing({ showingCount, totalLength }) {
  const t = useTranslations('catalog');
  return (
    <div className="showing-product-number text-right">
      <span>
        {
          t('showingCountOfLength', {
            count: showingCount,
            length: totalLength
          })
        }
      </span>
    </div>
  );
};
